export const LABELS = {
  SUMMARY: "Сводные показатели",
  FORECAST: "Прогнозные показатели",
};
